module.exports = __webpack_public_path__ + "static/media/soccer.a8915d8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/soccer.jpg
// module id = 694
// module chunks = 0